import { Component, Input } from '@angular/core';
import { EliminationMatrixResultView } from '@models/eliminationMatrixResultView';

@Component({
  selector: 'app-bvd-display',
  templateUrl: './bvd-display.component.html',
  styleUrls: ['./bvd-display.component.css'],
})
export class BvdDisplayComponent {
  @Input() comparable: EliminationMatrixResultView;
}
